import styled from "styled-components";
import * as antd from "antd";

export const SelectConnections = styled((props) => <antd.Select {...props} />)`
  margin-right: 10px;
`;
